import React from "react";
import { Trans } from 'react-i18next';
import { t } from 'i18next';
import * as R from "ramda";

import { PrimaryButtonS, SecondaryBtnS, Text, TextInput } from "../common";
import { DisplayFlexS } from "../../../utils/stylesHelpers";
import {
  BottomForm,
  CompanyLogoWrapS,
  Form,
  HeaderWrapper,
  InputWrapper,
  LogoWithUploadOverlayS,
  SelectImageTextS,
} from "./profileComponentS";

export const ProfileSettingsComponent = ({
  company,
  onSubmit,
  values,
  errors,
  onChange,
  onBlur,
  touched,
  toggleChangeAvatarModal,
  toggleChangePass,
  windowWidth,
  loadingPost,
}) => (
  <Form {...{ onSubmit }}>
    <DisplayFlexS direction='column' directionScreenMedium='column'>
      <HeaderWrapper>
        <CompanyLogoWrapS style={{ margin: 0 }}>
          <LogoWithUploadOverlayS
            logo={ company.logo }
          />
        </CompanyLogoWrapS>
        <DisplayFlexS direction='column' directionScreenMedium='column' style={{ marginLeft: 15 }}>
          {
            windowWidth > 768 ? (
              <SelectImageTextS onClick={() => toggleChangeAvatarModal(true)}>
                <Trans i18nKey='profile.settings.selectImage'/>
              </SelectImageTextS>
            ) : (
              <SecondaryBtnS transform='none' padding='10px 30px' onClick={() => toggleChangeAvatarModal(true)}>
                <Trans i18nKey='profile.settings.selectImage'/>
              </SecondaryBtnS>
            )
          }

        </DisplayFlexS>
      </HeaderWrapper>

      <DisplayFlexS direction='column' directionScreenMedium='column' style={{ marginTop: 20 }}>
        <InputWrapper width='50%'>
          <TextInput
            labelColor='primary'
            label={t('profile.labels.name')}
            name="name"
            type="text"
            value={ values.name }
            {...{ onChange, onBlur }}
            isError={R.prop('name', errors) && R.prop('name', touched)}
            error={errors.name}
          />
        </InputWrapper>
        <InputWrapper width='50%'>
          <TextInput
            labelColor='primary'
            label={t('profile.labels.email')}
            name="email"
            type="text"
            value={ values.email }
            {...{ onChange, onBlur }}
            isError={errors.email && touched.email}
            error={errors.email}
          />
        </InputWrapper>

        <DisplayFlexS justefy='start' directionScreenMedium='column' direction='column'>
          <Text align='left' fontFamily='bold'>
            <Trans i18nKey="profile.labels.password" />
          </Text>
          <DisplayFlexS style={{ alignItems: 'center', margin: '20px 0 30px' }}>
            {/* Leaving this as it will be implemented on the next stages */}
            <SecondaryBtnS type="button" padding='8px 20px' transform='none' onClick={() => toggleChangePass(true)} >
              <Trans i18nKey="profile.button.changePassword" />
            </SecondaryBtnS>
          </DisplayFlexS>
        </DisplayFlexS>
      </DisplayFlexS>
    </DisplayFlexS>
    <BottomForm>
      <PrimaryButtonS loading={loadingPost} type="submit" padding='5px 45px'>
        <Trans i18nKey="profile.button.save" />
      </PrimaryButtonS>
    </BottomForm>
  </Form>
);
